
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"siteMapPageQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inverterList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tableList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geom"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pileGeoJsonList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoJsonTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tableGeoJsonList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoJsonTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pilingMachineList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PilingMachineTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"enums"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnumsTypeBase"},"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"siteMapTableQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"table"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TableTypeBase"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"piles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PileTypeBase"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enums"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnumsTypeBase"},"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"noiseMapPageQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tableGeoJsonList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoJsonTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pilingMachineList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PilingMachineTypeBase"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"enums"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnumsTypeBase"},"directives":[]}]}}]}}],"loc":{"start":0,"end":929}};
    doc.loc.source = {"body":"#import \"../fragments/enums_type_base_fragment\"\n#import \"../fragments/table_type_base_fragment\"\n#import \"../fragments/pile_type_base_fragment\"\n#import \"../fragments/piling_machine_type_base_fragment\"\n#import \"../fragments/inverter_type_base_fragment\"\n#import \"../fragments/geojson_type_base_fragment\"\n\nquery siteMapPageQuery {\n  inverterList {\n    id\n    name\n  }\n  tableList {\n    id\n    name\n    geom\n  }\n  pileGeoJsonList {\n    ...GeoJsonTypeBase\n  }\n  tableGeoJsonList {\n    ...GeoJsonTypeBase\n  }\n  pilingMachineList {\n    ...PilingMachineTypeBase\n  }\n  enums {\n    ...EnumsTypeBase\n  }\n}\n\nquery siteMapTableQuery($tableId: ID!) {\n  table(id: $tableId) {\n    ...TableTypeBase\n    piles {\n      ...PileTypeBase\n    }\n  }\n  enums {\n    ...EnumsTypeBase\n  }\n}\n\nquery noiseMapPageQuery {\n  tableGeoJsonList {\n    ...GeoJsonTypeBase\n  }\n  pilingMachineList {\n    ...PilingMachineTypeBase\n  }\n  enums {\n    ...EnumsTypeBase\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/enums_type_base_fragment").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/table_type_base_fragment").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/pile_type_base_fragment").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/piling_machine_type_base_fragment").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/inverter_type_base_fragment").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/geojson_type_base_fragment").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["siteMapPageQuery"] = oneQuery(doc, "siteMapPageQuery");
        
        module.exports["siteMapTableQuery"] = oneQuery(doc, "siteMapTableQuery");
        
        module.exports["noiseMapPageQuery"] = oneQuery(doc, "noiseMapPageQuery");
        
